<template>
    <main-content>
        <kt-panel class="mb-0">
            <div v-if="marketer_specific_setting.show_settlements_reports_status === 1 && !($can('read', 'marketing'))">
                <router-link class="kt-nav__link btn btn-primary float-right" to="/marketing/subsets-settlements">
                    {{ $t('marketing.dashboard.subset_settlements') }}
                </router-link>
            </div>
            <kt-panel-header>
                <kt-panel-header-toolbar class="w-100">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', active_pane === '#user-info' ? 'active' : '']" data-toggle="tab"
                               @click="gotoTab('#user-info')" href="#user-info" role="tab" aria-selected="false"
                            >
                                {{ $t('aside.home') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', active_pane === '#user-info' ? 'active' : '']" id="user_info">
                        <div v-if="$can('read', 'marketing')">
                            <manage-filter :action="filterAction"/>
                        </div>
                        <div v-else>
                            <common-filter :action="filterAction"/>
                        </div>
                        <div v-if="status == 'success'">
                            <kt-row v-if="$can('read', 'marketing')">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <balance-statistics
                                            :Balance="data.manage_balance"
                                            :ProfitAmount="data.marketers_profit_amount"
                                            :SettlementedAmount="data.settlemented_amount"
                                            :TitleBalance="$t('marketing.dashboard.admin.balance')"
                                            :TitleProfitAmount="$t('marketing.dashboard.admin.total_profit')"
                                            :TitleSettlement="$t('marketing.dashboard.admin.settlemented_amount')"
                                            :needCurrency="true"
                                            :needPercent="false"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <subsets-statistics
                                            :RegisteredNumber="data.registered_with_referer"
                                            :MarketersNumber="data.marketers_number"
                                            :TotalClicks="data.total_clicks"
                                            :TitleRegisteredUsers="$t('marketing.dashboard.admin.registered_users')"
                                            :TitleMarketersNumber="$t('marketing.dashboard.admin.marketers_number')"
                                            :TitleTotalClicks="$t('marketing.dashboard.admin.total_clicks')"
                                    />
                                </div>
                            </kt-row>
                            <kt-row v-else>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <user-balance
                                            :Balance="data.marketer_balance"
                                            :ProfitAmount="data.marketer_profit_amount"
                                            :TitleProfitAmount="$t('marketing.dashboard.total_profit')"
                                            :TitleBalance="$t('marketing.dashboard.settlement_balance')"
                                            :needCurrency="true"
                                            :needPercent="false"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <user-subsets
                                            :SubsetsNumber="data.subsets_number"
                                            :ClicksNumber="data.clicks_number"
                                            :MarketingLevel="data.marketing_level"
                                            :TitleSubsets="$t('marketing.dashboard.subsets_number')"
                                            :TitleClicks="$t('marketing.dashboard.click_number')"
                                            :TitleLevel="$t('marketing.dashboard.level')"
                                            :needCurrency="true"
                                            :needPercent="false"
                                    />
                                </div>
                            </kt-row>
                            <div v-if="marketerSettingStatus === 'success-specific-marketer'">
                                <kt-datatable v-if="$can('read', 'marketing')"
                                              v-bind="datatableManageProps" ref="datatable">
                                </kt-datatable>
                                <kt-datatable v-else-if="marketer_specific_setting.show_transactions_reports_status === 1"
                                              v-bind="datatablePropsWithActions"
                                              ref="datatable"
                                >
                                </kt-datatable>
                                <kt-datatable v-else v-bind="datatableProps" ref="datatable"></kt-datatable>
                            </div>
                        </div>
                    </div>
                </div>

            </kt-panel-body>
        </kt-panel>
      <p class="font-weight-bold">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
        <span>
              آمار نشان داده شده تا روز قبل محاسبه شده است.
              </span>
      </p>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import manageFilter from './components/manage-filter'
    import commonFilter from './components/common-filter'
    import balanceStatistics from './components/balance-statistics'
    import subsetsStatistics from './components/subsets-statistics'
    import userBalance from './components/user-balance-statistics'
    import userSubsets from './components/user-subsets-statistics'
    import {mapGetters} from "vuex";
    import ManageFilter from "./components/manage-filter";
    import CommonFilter from "./components/common-filter";
    import columns from "./datatable/columns";
    import manageAccessColumnsGateways from "./datatable/manageAccessColumnsGateways";
    import actionsColumn from "./components/actions-column";
    import { ApiUrl } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import actionsColumnManualUser from "./components/actions-columns-manual-user";
    import IranSheba from "iran-sheba";
    import { marketingService } from '@/common/api.service'
    import toastr from "toastr";
    import $ from "jquery";
    import {KTApp} from "@/plugins/core/app";


    export default {
        name: 'StarshopMarketingDashboard',
        components: {
            CommonFilter,
            ManageFilter,
            'main-content': mainContent,
            'manage-filter': manageFilter,
            'common-filter': commonFilter,
            'balance-statistics': balanceStatistics,
            'subsets-statistics': subsetsStatistics,
            'user-balance': userBalance,
            'user-subsets': userSubsets,
        },
        data() {
            return {
                active_pane: '#user-info',
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                userActionsColumn: null,
                marketer_id: 'current',
                query: {},
                filter_sheba_number: null,
                sheba_id : null ,
            }
        },
        computed: {
            ...mapGetters('marketing', [
                'data',
                'status',
                'marketerSettingStatus',
                'marketer_specific_setting'
            ]),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            },
            datatableProps() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.starshopPath('marketing/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,

                }
            },
            datatableManageProps() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.starshopPath('marketing/admin/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumnsGateways,
                    actions: actionsColumn,

                }
            },
            datatablePropsWithActions() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.starshopPath('marketing/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumnManualUser
                }
            },
            ...mapGetters('user', [
                'current_user'
            ]),
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
                let is_admin = this.$can('read', 'marketing')
                this.$store.dispatch('marketing/fetchStarshopData', {query: query, is_admin: is_admin})
            },
            gotoTab(selectedTab) {
                this.active_pane = selectedTab;
                window.localStorage.setItem('user_details_active_tab', selectedTab);
            }
        },
        async created() {
            await this.$store.dispatch('user/fetchCurrent')
            let is_admin = this.$can('read', 'marketing')
            this.$store.dispatch('marketing/fetchStarshopData',{query: '', is_admin: is_admin})
            this.$store.dispatch('marketing/fetchStarshopSpecificMarketerSetting', this.marketer_id)
        },
    }
</script>

<style >
    .line-divider {
        height: 1px;
        background-color: #777;
    }
</style>
